import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";

const EASE = [0.22, 1, 0.36, 1];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-4xl px-6 py-24 sm:px-10 sm:py-32">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="mb-12 text-center"
      >
        <p className="font-mono-accent mb-4 text-xs uppercase tracking-[0.24em] text-amber-600">
          Good to Know
        </p>
        <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
          Frequently Asked{" "}
          <span className="font-serif-accent font-medium italic text-slate-500">Questions</span>
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
      >
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-stone-200"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-display text-left text-base font-semibold text-slate-900 hover:text-amber-700 hover:no-underline sm:text-lg"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="text-sm leading-relaxed text-slate-600 sm:text-base"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </section>
  );
}
